"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_case__study__or__reports__or__white__paper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "590ae16a-3872-4cd0-83ed-ec29adcfdb14",
    "data-name": "reports-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "87bf540b-9a8f-4141-a49b-00636f985ca5",
    x1: 108.91,
    y1: 66.19,
    x2: 177.85,
    y2: 135.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "reports-hi"), /*#__PURE__*/React.createElement("g", {
    id: "7ef01cea-9533-44e1-8424-a78ac4510d11",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed616829-057a-48dc-bbe5-4161d821ad2c",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cf39fcdc-8112-4c76-a819-d6cd7fcb2128",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e0bef6bb-3170-49a2-8630-506e3a19df43",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "85e4add3-f590-4b63-a741-15b8d3927f2b",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c4e1a9f2-3504-492e-a2fc-78114e3bd5a5",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d1a10362-c31b-4ac3-b4e6-39cfa30057d8",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c9cc2080-47e9-419d-b9b4-4ecef76e9c91",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "69acc7b0-1a9a-4a9b-93ba-3f585524999a",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82711734-bdee-448e-a21a-3e2cc12749d4",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e087c2dd-777b-4bcd-be96-2b2bacec4607",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f5f158f4-a4b2-444e-b592-41b28efe3395",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c4f2b92-07f6-4ff9-b67e-830645899972",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "705e5bf6-d581-4ddc-b208-ed2f49f90bfe",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "70e05428-b58c-4a66-9253-0c886552d4ae",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "650d53b2-faca-4d71-99fb-e1950504cb64",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3d8f5649-85e4-4924-9e85-5e682eaebb78",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a84d5521-e1f3-4e8f-8c74-b20bbbba497a",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 16,
    width: 104.5,
    height: 144,
    rx: 12,
    ry: 12,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 16,
    width: 104.5,
    height: 144,
    rx: 12,
    ry: 12,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,160h-7.77l-.1-125L160,55.08,160,148A12,12,0,0,1,148,160Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#87bf540b-9a8f-4141-a49b-00636f985ca5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 104.25,
    height: 144,
    rx: 12,
    ry: 12,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 107,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    transform: "translate(181 218) rotate(-180)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 91,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    transform: "translate(181 186) rotate(-180)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 75,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    transform: "translate(181 154) rotate(180)",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 123,
    width: 64,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    transform: "translate(181 250) rotate(180)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,158h-3.75v2H148a12,12,0,0,0,12-12v-2A12,12,0,0,1,148,158Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,174H52a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12h80.25a12,12,0,0,0,12-12v-2A12,12,0,0,1,132.25,174Z",
    transform: "translate(0 0)"
  })))))))))))))))))))))));
}

var _default = ic_case__study__or__reports__or__white__paper;
exports.default = _default;